import { TextShape } from './text-shape';
import { Container, ITextStyle, Sprite, TextStyle, Texture } from 'pixi.js';
import { RectangleElement } from '../primitive/rectangle-element';
import {
  NewTextAnimation,
  TextAnimationConfig,
} from '../../../../elements/resource/types/shape.type';
import { IncrementController } from '../../../animation/frame/increment/controller/increment.controller';
import { TextWord } from './text-word';
import { TextLetter } from './text-letter';
import gsap from 'gsap';
import { GradientFilter } from './gradient-filter';
import _ from 'lodash';
import { TextElement } from '../primitive/text-element';
import { _screenX, _screenY } from '../../../../services/canvas/canvas.service';
import { Text } from 'pixi.js';
import { TextAnimationStep } from '../../../animation/text-animation.service';
import { StudioTextShape } from '../../../store/studio/text/studio-text-shape';
import { StudioTextAnimationStep } from '../../../store/studio';
import { KawaseBlurFilter } from 'pixi-filters';
import { e } from 'mathjs';

export interface TextLineDescriptor {
  width: number;
  wrapped: boolean;
}

export class TextLine {
  words: TextWord[];
  get textShape() {
    return this.parent;
  }
  style: TextStyle;
  get index() {
    return this.config.index;
  }

  get prev(): TextLine {
    return this.textShape.lines[this.index - 1];
  }

  get next(): TextLine {
    return this.textShape.lines[this.index + 1];
  }

  get lineHeight() {
    return this.config.lineHeight;
  }

  get width() {
    return this.descriptor.width;
  }

  get wrapped() {
    return this.descriptor.wrapped;
  }

  get letters() {
    return this.words.reduce(
      (acc, word) => [...acc, ...word.letters],
      [],
    ) as TextLetter[];
  }
  container: Container;

  element: TextElement;
  constructor(
    private readonly parent: TextShape | StudioTextShape,
    private readonly descriptor: {
      words: { text: string; width: number }[];
      wrapped: boolean;
      width: number;
    },
    private readonly config: {
      index: number;
      maxLineWidth: number;
      lineHeight: number;
      letterIndexOffset: number;
      style: ITextStyle;
      width: number;
    },
  ) {
    // This override is not needed
    this.style = new TextStyle({
      ...config.style,
      wordWrap: false,
      wordWrapWidth: Infinity,
    });

    this.container = new Container();
    this.parent.container.addChild(this.container);
    let leftOffset = 0;
    let rightOffset = 0;

    // this.style.align = 'left'; //
    switch (this.style.align) {
      case 'left':
        rightOffset = config.maxLineWidth - this.width;
        rightOffset = leftOffset;
        break;
      case 'right':
        leftOffset = config.maxLineWidth - this.width;
        break;
      case 'center':
      default:
        leftOffset = (config.maxLineWidth - this.width) / 2;
        break;
    }

    // leftOffset = (config.maxLineWidth - this.width) / 2;
    // rightOffset = leftOffset;

    // -- // -- // -- //
    // this.container.setTransform(leftOffset, 0);
    let letterIndexOffset = config.letterIndexOffset;

    this.container.y =
      (this.textShape as StudioTextShape).absoluteLineHeight * this.index;

    if (
      this.descriptor.words.length == 1 &&
      this.descriptor.words[0].text == ''
    ) {
      this.words = [
        new TextWord(
          this,
          {
            text: '',
            width: 0,
          },
          {
            index: 0,
            leftOffset,
            rightOffset,
            lineHeight: this.lineHeight,
            lineYOffset: 0,
            lineWordIndex: 0,
            startCharacterIndex: letterIndexOffset,
            width: 0,
          },
        ),
      ];
      return;
    }

    let xOffset = leftOffset;

    this.words = descriptor.words.map((word, index) => {
      // -- // -- // -- // -- //
      const textWord = new TextWord(this, word, {
        index,
        xOffset,
        // The first word has the left offset
        leftOffset: index == 0 ? leftOffset : 0,
        // leftOffset,
        // The last word has the right offset
        rightOffset: index == descriptor.words.length - 1 ? rightOffset : 0,
        lineHeight: this.lineHeight,
        lineWordIndex: index,
        startCharacterIndex: letterIndexOffset,
        lineYOffset: this.textShape.grossLineHeight * this.index,
        width: word.width,
      });

      const { text, width } = word;
      letterIndexOffset += text.length;
      xOffset += width;
      return textWord;
    });

    // this.element = new TextElement(this.textShape, this.container, {
    //   ...(this.textShape.elementStyle as any),
    //   text: this.words.map(word => word.text).join(''),
    //   x: 0,
    //   y: 0,
    //   fill: '#fff',
    //   // log: this.config.char == 'r',
    //   // fill: gradient,
    // });

    // const pixiText = this.element._element; // or .element

    // this.addColorGradient(pixiText);

    // Simple approach - hard to animate
    // this.element._element.style = {
    //   ...this.element._element.style,
    //   fill: ['#8ba8c8ff', '#993d7fff', '#8d29afff'],
    //   fillGradientStops: [0, 0.5, 1],
    //   fillGradientType: 1,
    // };
  }

  previousSegment: [number, number] | null = null;
  currentSegment: [number, number] | null = null;
  appearInitialized = false;

  gsapAnimate(animation: StudioTextAnimationStep): {
    timeline: gsap.core.Timeline;
    onStartFcns: Array<() => void>;
  } {
    console.log('text-line > gsapAnimate', animation);
    const timeline = gsap.timeline();
    const onStartFcns: Array<() => void> = [];
    const { duration, type: baseType, line, word, hold } = animation;
    if (!line && !word) {
      return { timeline, onStartFcns };
    }

    // If it is an appear animation and it is the time it is called
    // we make every word invisible // -- // -- // -- // -- // -- //
    const { type, letter, duration: lineDuration } = line || {};

    const actualDuration = (lineDuration || duration || 1) - (hold || 0);

    // -- // -- //

    // if (letter) {
    //   const letterTimeline = gsap.timeline();

    //   // Calculate timing for letter-by-letter appearance
    //   const letterCount = this.letters.length;
    //   const totalDuration = lineDuration || duration || 1;

    //   const { overlap: letterOverlap } = letter;

    //   const letterDuration =
    //     totalDuration / (1 + (letterCount - 1) * (1 - letterOverlap || 0));
    //   const gap = letterDuration * (1 - letterOverlap || 0);

    //   this.letters.forEach((l, index) => {
    //     if (l.element?._element) {
    //       letterTimeline.add(
    //         gsap.to(l.element._element, {
    //           duration: letterDuration,
    //           alpha: 1,
    //           ease: 'power1.out',
    //         }),
    //         index * gap,
    //       );
    //     }
    //   });
    //   timeline.add(letterTimeline, 0);
    // }

    if (baseType == 'appear' && !this.appearInitialized && !letter) {
      this.container.alpha = 0;
      timeline.add(
        gsap.to(this.container, {
          duration: lineDuration || duration || 1,
          alpha: 1,
          ease: 'power1.inOut',
        }),
        0,
      );
    }

    const { align, translate, alternate } = line || {};

    const segment = line?.segment || [0, this.words.length];
    // solve only the segment // -- // -- // -- // -- //

    let wordsInScope = this.words;
    if (segment) {
      if (baseType == 'appear') {
        this.words.map(word => (word.container.alpha = 0));
      }

      timeline.eventCallback('onStart', () => {
        const [start, end] = segment;
        for (let i = 0; i < start; i++) {
          this.words[i].container.alpha = 0;
        }
        if (align) {
          this.container.x = this.alignBySegment([segment[0], segment[0] + 1]);
        } else {
          this.container.x = this.alignBySegment(segment);
        }
      });

      const [start, end] = segment;
      wordsInScope = this.words.slice(start, end);
    }

    if (word) {
      // The dymanic align makes sense only if we have word animation
      const { d: itemDuration, gap } =
        this.textShape.service.animationService.makeOverlapTiming(
          (wordsInScope.length + 1) / 2,
          actualDuration,
          word.overlap,
        );

      if (align) {
        // wordsInScope
        //   .filter(word => word.text !== ' ')
        //   .map((word, index) => {
        //     timeline.add(
        //       gsap.to(
        //         { x: 0 },
        //         {
        //           duration: 0,
        //           x: 1,
        //           onStart: () => {
        //             this.container.x = this.alignBySegment([
        //               start + 1,
        //               start + index * 2 + 2,
        //             ]);
        //           },
        //         },
        //       ),
        //       index * gap,
        //     );
        //   });

        timeline.add(
          gsap.to(this.container, {
            duration: actualDuration,
            x: this.alignBySegment(segment),
          }),
          actualDuration * 0.2,
        );
      }

      wordsInScope
        .filter(word => word.text !== ' ')
        .map((word, index) => {
          timeline.add(
            gsap.to(word.container, {
              duration: itemDuration / 2,
              alpha: 1,
              ease: 'power1.inOut',
            }),
            index * gap,
          );
        });
    } else {
      wordsInScope.map(word => {
        timeline.add(
          gsap.to(word.container, {
            duration: lineDuration || duration || 1,
            alpha: 1,
            ease: 'power1.inOut',
          }),
          0,
        );
      });
    }

    // if (align == 'static') {
    // now this is the default case

    // -- //

    // }

    // -- //
    // if (align == 'dynamic') {
    //   const x = 0;
    //   timeline.add(
    //     gsap.to(this.container, {
    //       duration: animation.duration || 1,
    //       x,
    //       ease: 'power1.inOut',
    //     }),
    //     0,
    //   );
    // }
    // // -- //
    // switch (start) {
    //   case 0:
    //     if (align == 'static') {
    //       this.container.x = this.alignBySegment(line.segment);
    //       console.log('alignBySegment', this.container.x);
    //     }

    //     if (word) {
    //       return;
    //     }
    //     console.log('setting the words in scope to alpha 1', {
    //       words: this.words.slice(start, end),
    //     });
    //     this.words.slice(start, end).map(word => (word.container.alpha = 1));
    //     onStartFcns.push(() => {
    //       this.currentSegment = line.segment;
    //     });

    //     break;
    // }

    // -- //
    if (translate) {
      const { timeline: lineTranslateTimeline, onStartFcns } =
        this.gsapTranslate(animation);
      timeline.add(lineTranslateTimeline, 0);
      onStartFcns.push(...onStartFcns);
    }

    const target = [
      'an',
      'easy-to-use',
      'video',
      'tool',
      'where',
      'you',
      'can',
      'upload',
      'files',
      'files,',
      'website',
      'url',
      'text',
      'text,',
    ];

    if (word) {
      const { overlap: wordOverlap, translate: wordTranslate } = word;

      const n = Math.ceil(wordsInScope.length / 2);
      let wordDuration: number;
      if (!wordOverlap) {
        wordDuration = (animation.duration || 1) / n;
      } else {
        // duration = (n - 1) * overlap * itemDuration + itemDuration
        // duration = ((n - 1) * overlap + 1) * itemDuration
        // itemDuration = duration / ((n - 1) * overlap + 1)
        wordDuration =
          (animation.duration || 1) / ((1 - wordOverlap) * (n - 1) + 1);
      }

      if (!word.noFade) {
        // -- //

        wordsInScope
          .filter(word => word.text !== ' ')
          .map((word, index) => {
            word.container.alpha = 0;

            // timeline.add(
            //   gsap.to(filter, {
            //     duration: wordDuration,
            //     blur: 0,
            //     ease: 'power2.out',
            //   }),
            //   index * wordDuration * (1 - (wordOverlap || 0)),
            // );

            timeline.add(
              gsap.to(word.container, {
                duration: wordDuration,
                alpha: 1,
                ease: 'power1.inOut',
              }),
              index * wordDuration * (1 - (wordOverlap || 0)),
            );
          });
      } else {
        wordsInScope.map(word => (word.container.alpha = 1));
      }

      if (wordTranslate) {
        const { from } = wordTranslate;

        if (from) {
          const [x, y] = from;
          wordsInScope
            .filter(word => word.text !== ' ')
            .map((word, index) => {
              console.log('word', word.text);
              word.container.position.x += x;
              word.container.position.y += y;
              timeline.add(
                gsap.to(word.container, {
                  duration: wordDuration,
                  x: (i, target) => {
                    return target.x - x;
                  },
                  y: (i, target) => {
                    return target.y - y;
                  },
                  ease: 'power2.out',
                }),
                index * wordDuration * (1 - (wordOverlap || 0)),
              );
            });
        }
      }
    }

    if (letter) {
      const { overlap: letterOverlap, translate: letterTranslate } = letter;

      // Swith to wordsInScope
      const lettersInScope = wordsInScope.map(word => word.letters).flat();
      wordsInScope.map(word => (word.container.alpha = 1));

      lettersInScope.map(letter => (letter.element._element.alpha = 0));
      const n = lettersInScope.length;
      let letterDuration: number;
      if (!letterOverlap) {
        letterDuration = (animation.duration || 1) / n;
      } else {
        // duration = (n - 1) * overlap * itemDuration + itemDuration
        // duration = ((n - 1) * overlap + 1) * itemDuration
        // itemDuration = duration / ((n - 1) * overlap + 1)
        letterDuration =
          (animation.duration || 1) / ((1 - letterOverlap) * (n - 1) + 1);
      }

      lettersInScope.map((letter, index) => {
        timeline.add(
          gsap.to(letter.element._element, {
            duration: letterDuration,
            alpha: 1,
            ease: 'power1.inOut',
          }),
          index * letterDuration * (1 - (letterOverlap || 0)),
        );
      });

      if (letterTranslate) {
        const { from } = letterTranslate;

        if (from) {
          const [x, y] = from;
          lettersInScope.map((letter, index) => {
            if (!letter) {
              return;
            }
            letter.x += x;
            letter.y += y;
            timeline.add(
              gsap.to(letter, {
                duration: letterDuration,
                x: (i, target) => {
                  return target.x - x;
                },
                y: (i, target) => {
                  return target.y - y;
                },
                // ease: 'power1.inOut', //
              }),
              index * letterDuration * (1 - (letterOverlap || 0)),
            );
          });
        }
      }
    }

    if (baseType === 'effect') {
      const blink =
        (animation as any).effect?.blink || animation.effects?.blink;
      if (blink) {
        const cnt = Math.max(1, +blink.cnt || 1);
        const total = animation.duration || 1;
        const half = total / cnt / 2;
        const targets = (
          line?.segment
            ? this.words.slice(line.segment[0], line.segment[1])
            : this.words
        ).map(w => w.container);

        for (let i = 0; i < cnt; i++) {
          timeline.add(
            gsap.to(targets, {
              duration: half,
              alpha: 0.2,
              ease: 'power1.inOut',
            }),
            i * 2 * half,
          );
          timeline.add(
            gsap.to(targets, {
              duration: half,
              alpha: 1,
              ease: 'power1.inOut',
            }),
            i * 2 * half + half,
          );
        }
      }
    }

    return { timeline, onStartFcns };
  }

  maskRectangle: RectangleElement;
  gsapTranslate(animation: StudioTextAnimationStep): {
    timeline: gsap.core.Timeline;
    onStartFcns: Array<() => void>;
  } {
    const timeline = gsap.timeline();
    const onStartFcns: Array<() => void> = [];
    // -- //
    const { duration, line } = animation;
    const { translate, duration: lineDuration } = line || {};
    const alternate = false;
    const { from, to, mask } = translate || {};
    // console.log('from', from, 'to', to);

    if (mask) {
      // console.log('init-mask', this.container.width, this.container.height); //
      this.maskRectangle = new RectangleElement(
        this.textShape,
        this.textShape.container,
        {
          position: {
            x: this.container.x,
            y: this.container.y,
          },
          width: this.textShape.maxLineWidth,
          height: this.textShape.baseLineHeight,
          fill: '#000000',
          opacity: 0.001,
        },
      );
      this.container.mask = this.maskRectangle.element;
    }

    if (from) {
      // const [x, y] = from.map(v => v + 0.2 * this.index * v);
      const [x, y] = from;
      this.container.position.x += x;
      this.container.position.y += y;

      timeline.add(
        gsap.to(this.container.position, {
          duration: lineDuration || duration || 1,
          x: (i, target) => {
            // console.log('----- start x------', target.x);

            if (alternate && this.index % 2 == 1) {
              return target.x + x;
            }

            return target.x - x;
          },
          y: (i, target) => {
            if (alternate && this.index % 2 == 1) {
              return target.y + y;
            }
            return target.y - y;
          },
          // ease: 'power1.inOut',
        }),
        0,
      );
    }

    if (to) {
      const [xTo, yTo] = to;
      timeline.add(
        gsap.to(this.container.position, {
          duration: lineDuration || duration || 1,
          x: (i, target) => {
            return target.x + xTo;
          },
          y: (i, target) => {
            return target.y + yTo;
          },
        }),
        0,
      );
    }

    return { timeline, onStartFcns };
  }

  gsapSegmentHighlight(text: string, duration: number, last = false) {
    const targetWords = this.words.filter(word => text.includes(word.text));

    const appear = gsap.timeline();
    targetWords.map((word, index) => {
      appear.add(
        gsap.to(word.container, {
          duration: duration * 0.25,
          alpha: 1,
        }),
        0,
      );
    });

    const disappear = gsap.timeline();

    if (last) {
      targetWords.map((word, index) => {
        disappear.add(
          gsap.to(word.container, {
            duration: duration * 0.25,
            alpha: 1,
          }),
          0,
        );
      });
    } else {
      targetWords.map((word, index) => {
        disappear.add(
          gsap.to(word.container, {
            duration: duration * 0.25,
            alpha: this.textShape.textConfig?.opacity || 0,
          }),
          0,
        );
      });
    }

    appear.add(disappear, duration * 0.5);
    return appear;
  }

  alignBySegment(segment: [number, number]) {
    const [start, end] = segment || [0, this.words.length];

    const previousSegmentWidth = this.words
      .slice(0, start)
      .reduce((acc, word) => acc + word.width, 0);

    const currentSegment = this.words.slice(start, end);
    const completeWidth = this.words.reduce((acc, word) => acc + word.width, 0);
    const segmentWidth = currentSegment.reduce(
      (acc, word) => acc + word.width,
      0,
    );
    return (completeWidth - segmentWidth) / 2 - previousSegmentWidth;
  }

  addColorGradient(pixiText: Text) {
    this.gradientTexture = this.createGradientTexture(
      2 * pixiText.width,
      pixiText.height,
    );
    this.gradientSprite = new Sprite(this.gradientTexture);
    // gradientSprite.anchor.set(0.5);
    this.gradientSprite.position.copyFrom(pixiText.position);
    this.gradientSprite.x = -pixiText.width;
    this.container.addChild(this.gradientSprite);

    this.gradientSprite.mask = this.element.element;

    pixiText.style.fill = 0xffffff; // or [0xffffff];
    pixiText.alpha = 1;
    pixiText.visible = true;
  }

  gradientTexture: Texture;
  gradientSprite: Sprite;

  createGradientTexture(width: number, height: number) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d')!;

    const gradient = ctx.createLinearGradient(0, 0, width, 0);
    gradient.addColorStop(0, '#0000ff');
    gradient.addColorStop(0.25, '#00ff00');
    gradient.addColorStop(0.5, '#ff0000');
    gradient.addColorStop(0.75, '#00ff00');
    gradient.addColorStop(1, '#0000ff');
    // -- // -- //

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    return Texture.from(canvas);
  }

  findLetterByPosition(x: number, strict = false) {
    // for (const word of this.words) {
    //   const res = word.isInMyRegion(x, strict);
    //   if (res) {
    //     return res;
    //   }
    // }
  }

  animate() {
    const length = this.words.length;
    for (let i = 0; i < length; i += 2) {
      // -- // -- //
    }
  }
  lettersShownTillIndex = 0;
  wordsInAppearScope: TextWord[];
  remainingWords: TextWord[];
  appearScope: [number, number];
  wordScopeEndIndex: number;
  containerShown = false;
  currentState?: 'initial' | 'segment-shown' = 'initial';

  gradientSpriteAnimation() {
    const timeline = gsap.timeline();
    const letters = this.letters;
    const duration = 2;
    const itemDuration = duration / letters.length;
    const ratio = 1 - 1 / 1.6;
    const _itemDuration = 0.3;

    timeline.add(
      gsap.to(this.gradientSprite, {
        duration: 1.5,
        diff: 0.5,
        x: 1000,
        ease: 'none',
        onStart: () => {},
        // onUpdate,
      }),
    );

    return timeline;
  }

  fadeInLine(input: NewTextAnimation): gsap.core.Timeline {
    return this.fadeInWordsAnimation(input, this.words);
  }
  tmpTranslate = 0;
  segmentWidth = 0;
  reset() {
    this.show();
    this.currentSegment = null;
    this.container.visible = true;
    // this.container.x = 0;
    this.container.scale.x = 1;
    this.container.scale.y = 1;
  }

  alignByShownWords(words: TextWord[]) {
    const align = 'center' as 'left' | 'right' | 'center';
    switch (align) {
      case 'left':
        // TODO - implement
        break;
      case 'right':
        // TODO - implement
        break;
      case 'center':
        const newWidth = words.reduce((acc, word) => acc + word.width, 0);
        /* console.log('alignByShownWords', {
          words,
          newWidth,
          maxLineWidth: this.textShape.maxLineWidth,
        }); */
        this.tmpTranslate = newWidth;
        this.segmentWidth = newWidth;
        this.container.setTransform(
          (this.textShape.maxLineWidth - newWidth) / 2,
          0,
        );
        break;
    }
  }

  patchLineHeight(lineHeight: number) {
    this.config.lineHeight = lineHeight;
    this.container.y =
      this.config.lineHeight * this.textShape.fontSize * 1.2 * this.index;
  }

  show() {
    this.container.alpha = 1;
    this.words.map(word => word.show());
  }

  // animationWordShift(
  //   timeline: gsap.core.Timeline,
  //   input: TextMoveAnimmation,
  //   words: TextWord[],
  // ) {
  //   const { type, translate, duration } = input;

  //   console.log('animationWordShift', words);
  //   timeline.to(this.container, {
  //     duration,
  //     x: 0,
  //     ease: 'power4.inOut',
  //   });

  //   const wordTimeline = gsap.timeline();
  //   timeline.add(wordTimeline, 0.5);
  //   // -- //
  //   const itemDuration = (duration || 1) / words.length;
  //   const overlapSec = itemDuration * 2;

  //   // console.log('overlap', overlapSec); // -- //

  //   if (type == 'fade') {
  //     const timeline2 = this.fadeInWordsAnimation(input, words);
  //     timeline.add(timeline2, 0);
  //     return;
  //   }

  //   if (type == 'mask') {
  //     // -- // -- // -- //
  //     const width = this.words.reduce((acc, word) => acc + word.width, 0);
  //     console.log('--- mask ---', {
  //       width,
  //       height: this.textShape.baseLineHeight,
  //     });
  //     const maskTex = this.makeHorizontalGradientMask(
  //       width,
  //       this.textShape.baseLineHeight,
  //     );
  //     const sprite = new Sprite(maskTex);
  //     sprite.anchor.set(0, 0);
  //     sprite.x = this.tmpTranslate;
  //     sprite.y = 0;
  //     this.container.addChild(sprite);
  //     const letters = words.reduce((acc, word) => {
  //       acc.push(...word.letters);
  //       return acc;
  //     }, []);
  //     letters.forEach(letter => letter.element.setMask(sprite));
  //   }

  //   // -- // -- //
  //   words.forEach((word, i) => {
  //     wordTimeline.to(
  //       word.container,
  //       {
  //         duration: duration / words.length,
  //         alpha: 1,
  //         ease: CustomEase.create(
  //           'custom',
  //           'M0,0 C0,0 0.034,0.154 0.045,0.226 0.083,0.505 0.24,1 0.293,1.087 0.327,1.144 0.415,1.238 0.452,1.238 0.498,1.238 0.56,1.138 0.577,1.119 0.631,1.054 0.654,0.953 0.704,0.921 0.746,0.892 0.794,0.881 0.836,0.931 0.87,0.972 0.884,1.056 0.93,1.056 0.945,1.056 0.986,0.999 1,1 ',
  //         ),
  //         // ease: 'power4.inOut',
  //       },
  //       i == 0 ? 0 : `-=${overlapSec}`,
  //     );
  //     // -- // -- //
  //     if (translate.from == 'bottom') {
  //       wordTimeline.from(
  //         word.container,
  //         {
  //           duration: 3 * itemDuration,
  //           y: this.textShape.fontSize * 0.6,
  //           ease: CustomEase.create(
  //             'custom',
  //             'M0,0 C0,0 0.099,0.392 0.122,0.551 0.157,0.796 0.206,0.991 0.31,1.123 0.377,1.208 0.489,1.35 0.591,1.319 0.699,1.285 0.782,1.169 0.824,1.117 0.887,1.038 0.893,1.021 1,1 ',
  //           ),
  //         },
  //         i == 0 ? 0 : `-=${overlapSec}`,
  //       );
  //     }
  //     // -- // -- //
  //   });
  // }

  fadeInWordsAnimation(
    input: NewTextAnimation,
    words: TextWord[],
  ): gsap.core.Timeline {
    const timeline = gsap.timeline();

    // -- //

    console.log('fadeInWordsAnimation', words); // -- // -- //
    const width = words.reduce((acc, word) => acc + word.width, 0);

    const height = this.textShape.baseLineHeight;
    const fadePx = 250;

    // build the soft-edge mask (white -> transparent on the RIGHT edge)
    const maskTex = this._makeHorizontalGradientMask(width, height, fadePx);

    const sprite = new Sprite(maskTex);
    sprite.anchor.set(0, 0);
    sprite.y = 0;

    // IMPORTANT: add the mask to the SAME parent as the letters, so local coords match
    this.container.addChild(sprite); // -- //

    const letters = words.reduce((acc, word) => {
      acc.push(...word.letters);
      return acc;
    }, []);

    // -- //
    // words.map(word => (word.container.alpha = 1));
    // -- // -- //
    // letters.forEach(letter => letter.element.setMask(sprite));
    words.forEach(word => word.textElement.setMask(sprite)); // -- // -- //
    // Or: this.container.mask = sprite;  // if you want to mask all at once

    // Start with the opaque part completely left of the text, so nothing shows
    // (solid area width is `width`, plus `fadePx` gradient tail)
    sprite.x = -(width + fadePx);

    // Slide mask right until its left edge aligns with the text's left
    timeline.to(sprite, {
      duration: 1,
      x: 0,
      ease: 'power4.inOut',
      onComplete: () => {
        // optional cleanup once fully revealed
        // letters.forEach(letter => letter.element.setMask(null));
        // or: this.container.mask = null;
        sprite.destroy({ texture: true, baseTexture: true });
      },
    });

    return timeline;
  }

  addGradientFilter() {
    const gradientFilter = new GradientFilter({
      angle: 0,
      colorA: [1, 0, 0],
      colorB: [0, 0, 1],
    });

    this.words[0].letters[0].element.element.filters = [gradientFilter];
    // this.container.filters = [gradientFilter];
  }

  addAlphaGradientFilter() {
    console.log('-------- addAlphaGradientFilter -------');
    const shadow = this.textShape.createContainerDropShadow(this.container, {
      color: '#af96ca',
      blur: 12,
      padding: 1,
      radius: 1,
      quality: 1,
      alpha: 0.6,
      offset: { x: 0, y: 0 },
    });
  }

  /**
   * Build a horizontal alpha-mask texture:
   * - solidSide = 'left'  -> solid white on the LEFT, fading to transparent on the RIGHT
   * - solidSide = 'right' -> solid white on the RIGHT, fading to transparent on the LEFT
   *
   * White (opaque) parts of the mask show the content; transparent parts hide it.
   * `fadePx` controls the width of the soft gradient edge.
   *
   * The canvas is drawn at devicePixelRatio for crisp masks.
   */

  fadeOutWordsAnimation(
    input: NewTextAnimation,
    words: TextWord[],
  ): gsap.core.Timeline {
    // const gradientFilter = new GradientFilter({
    //   angle: 0,
    //   colorA: [1, 0, 0],
    //   colorB: [0, 0, 0],
    // });
    // console.log('fadeOutWordsAnimation', input);
    // // words
    // //   .flatMap(w => w.letters)
    // //   .forEach(l => (l.element.element.filters = [gradientFilter]));
    // // -- // -- // -- //
    // const bounds = this.container.getBounds(); // world coords
    // this.container.filterArea = bounds;
    // console.log('bounds', bounds);
    // // this.container.addChild(gradientFilter);
    // this.container.filters = [gradientFilter];
    // return gsap.timeline();
    // return gradientFilter.animateToColors({
    //   toA: 0x000023,
    //   toB: 0x3400234,
    //   duration: 2,
    //   ease: 'power4.inOut',
    //   onStart: () => {
    //     // words.map(word => (word.container.filters = [gradientFilter]));
    //     words
    //       .flatMap(w => w.letters)
    //       .forEach(l => (l.element.element.filters = [gradientFilter]));
    //     // this.container.filters = [gradientFilter];
    //   },
    // });
    // //
    const { duration } = input;
    // -- // console.log('---------- fadeOutWordsAnimation -------------'); // -- //
    const timeline = gsap.timeline();

    const width = words.reduce((acc, word) => acc + word.width, 0);

    const height = this.textShape.baseLineHeight;
    const fadePx = 250;

    // build the soft-edge mask (white -> transparent on the RIGHT edge)
    const maskTex = this._makeHorizontalGradientMask(width, height, fadePx);

    const sprite = new Sprite(maskTex);
    sprite.anchor.set(0, 0);
    sprite.y = 0;

    sprite.alpha = 0;
    sprite.x = -fadePx;
    // IMPORTANT: add the mask to the SAME parent as the letters, so local coords match
    this.container.addChild(sprite); // -- //

    const letters = words.flatMap(w => w.letters);

    // // Slide mask right until its left edge aligns with the text's left
    timeline.to(sprite, {
      duration,
      x: width,
      // width: 0,
      ease: 'power4.inOut',
      onStart: () => {
        sprite.alpha = 1;
        letters.forEach(letter => letter.element.setMask(sprite));
      },
      onComplete: () => {
        // optional cleanup once fully revealed
        //  letters.forEach(letter => letter.element.setMask(null));
        // or: this.container.mask = null;
        // sprite.destroy({ texture: true, baseTexture: true });
      },
    });

    return timeline;
  }

  makeHorizontalGradientMask(width: number, height: number, fadePx = 0) {
    // Canvas to draw an opaque block + a right-edge gradient to transparent // -- //
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.ceil(width + fadePx));
    canvas.height = Math.max(1, Math.ceil(height));

    const ctx = canvas.getContext('2d')!;

    // 1) Solid white (fully visible) area
    ctx.fillStyle = 'rgba(255,255,255,1)';
    ctx.fillRect(0, 0, width, height);

    if (fadePx) {
      const g = ctx.createLinearGradient(width, 0, width + fadePx, 0);
      g.addColorStop(0, 'rgba(255,255,255,1)');
      g.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = g;
      ctx.fillRect(width, 0, fadePx, height);
    }

    return Texture.from(canvas);
  }

  _makeHorizontalGradientMask(width: number, height: number, fadePx = 0) {
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.ceil(width + fadePx));
    canvas.height = Math.max(1, Math.ceil(height));
    const ctx = canvas.getContext('2d')!;

    // Fill everything white first
    ctx.fillStyle = 'rgba(255,255,255,1)';
    ctx.fillRect(0, 0, width + fadePx, height);

    if (fadePx > 0) {
      // Remove (fade out) the left edge using destination-out
      ctx.globalCompositeOperation = 'destination-out';
      const g = ctx.createLinearGradient(0, 0, fadePx, 0);
      g.addColorStop(0, 'rgba(0,0,0,1)'); // fully remove at left
      g.addColorStop(1, 'rgba(0,0,0,0)'); // keep at fadePx
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, fadePx, height);
      ctx.globalCompositeOperation = 'source-over';
    }

    return Texture.from(canvas);
  }

  hideRectangle() {
    this.selectorRectangle?.hide();
    this.words.map(word => word.hide());
  }
  remove() {
    this.container.destroy();
    this.element?.remove();
    this.selectorRectangle?.remove();
    this.words?.map(word => word.remove());
    this.words = [];
  }

  getPrevWord(word: TextWord) {
    if (word.index == 0) {
      return this.prevLine?.lastWord;
    }
    return this.words[word.index - 1];
  }
  getNextWord(word: TextWord): TextWord {
    if (word.index == this.words.length - 1) {
      return this.nextLine?.firstWord;
    }
    return this.words[word.index + 1];
  }
  get prevLine() {
    return this.textShape.lines[this.index - 1];
  }

  get nextLine() {
    return this.textShape.lines[this.index + 1];
  }

  findWord(x: number, strict = false): [TextWord, number] {
    // -- //
    for (const word of this.words) {
      const res = word.isInMyRegion(x, strict);
      if (res) {
        return res;
      }
    }
  }
  get firstWord() {
    return this.words[0];
  }

  get lastWord() {
    return this.words[this.words.length - 1];
  }

  get cursorHeight() {
    if (this.textShape.lineHeight < 1) {
      return Math.min(this.textShape.baseLineHeight, this.lineHeight);
    }
    return Math.max(this.textShape.baseLineHeight, this.lineHeight);
  }

  scaleXIncrementController: IncrementController;
  scaleYIncrementController: IncrementController;
  translateXIncrementController: IncrementController;
  translateYIncrementController: IncrementController;
  animationState: {
    start: number;
    end: number;
    division: number;
    current: number;
    state: 'idle' | 'in-progress' | 'finished';
    config: TextAnimationConfig;
    // -- // -- // -- // -- //
  };

  pseudoAnimation(textAnimationStep: TextAnimationStep): gsap.core.Timeline {
    const { duration, line, word, letter } = textAnimationStep;

    // -- // -- // -- // -- // -- //
    const timeline = gsap.timeline();

    const { duration: lineDuration } = line || {};

    const object = { a: 0 };
    timeline.add(
      gsap.to(object, {
        duration: lineDuration || duration,
        a: 1,
        ease: 'none',
      }),
      0,
    );
    return timeline;
  }

  selectorRectangle: RectangleElement;

  removeSelectorRectangle() {
    this.selectorRectangle?.remove();
  }
}
